import { IAPIConfig, useApi } from "../../custom_hooks/useApi";

import { Box } from "@mui/material";
import CustomToast from "../../utils/cutomToast/CustomToast";
import Loader from "../../utils/loader/Loader";
import Signup from "../../organisms/Login/Signup";
import SignupWithEmail from "../../organisms/Login/SignupWithEmail";
import { login } from "../../store/authSlice";
import { urlConstants } from "../../components/constants/globalConstants";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

const Authentication = () => {
  const [step, setStep] = useState<"signup" | "signupWithEmail">("signup");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const { doApi } = useApi();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const ConnectGoogle = () => {
    window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?scope=openid%20profile%20email https://www.googleapis.com/auth/business.manage https://www.googleapis.com/auth/webmasters.readonly https://www.googleapis.com/auth/webmasters https://www.googleapis.com/auth/analytics.readonly https://www.googleapis.com/auth/userinfo.email&prompt=consent&access_type=offline&include_granted_scopes=true&response_type=code&state=state_parameter_passthrough_value&redirect_uri=${urlConstants.ENV_URL}/signin-google&flowName=GeneralOAuthFlow&client_id=${urlConstants.CLIENT_ID}`;
  };

  const handleGoogleLogin = async (credentialResponse: any) => {
    setLoading(true);
    const googlePayload = {
      token: credentialResponse.credential,
    };
    try {
      const loginGoogleConfig: IAPIConfig = {
        URL: "/google-login",
        method: "POST",
        payLoad: googlePayload,
      };
      doApi(loginGoogleConfig, "seedmain")
        .then((response: any) => {
          const res = response.data;
          if (res.success) {
            CustomToast(`Login Successful`, "success");
            const userResponse = res.data;
            const authData = {
              token: userResponse.token,
              userDetails: userResponse,
            };
            dispatch(login(authData));
            if (authData.userDetails.agencyDetails.length === 0) {
              ConnectGoogle();
            } else {
              navigate("/home");
            }
          } else {
            CustomToast(res.message, "error");
            sessionStorage.setItem("auth", "0");
          }
        })
        .catch((err: any) => {
          CustomToast(err, "error");
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (error) {
      console.error("Google Login Failed:", error);
      setLoading(false);
    }
  };

  const handleFormSubmit = async () => {
    if (
      email.trim() === "" ||
      password.trim() === "" ||
      confirmPassword.trim() === ""
    ) {
      CustomToast("Please enter all fields", "error");
      return;
    }
    if (password.trim() !== confirmPassword.trim()) {
      CustomToast("Password and Re-enter password must be same.", "error");
      return;
    }
    const payload = {
      email: email.trim(),
      password: password.trim(),
      rememberMe: true,
    };

    const loginConfig: IAPIConfig = {
      URL: "/login",
      method: "POST",
      payLoad: payload,
    };
    setLoading(true);
    doApi(loginConfig, "seedmain")
      .then((response: any) => {
        const res = response.data;
        if (res.success) {
          CustomToast(`Login Successful`, "success");
          const userResponse = res.data;
          const authData = {
            token: userResponse.token,
            userDetails: userResponse,
          };
          dispatch(login(authData));
          sessionStorage.setItem("auth", "1");
        } else {
          CustomToast(res.message, "error");
          sessionStorage.setItem("auth", "0");
        }
      })
      .catch((err: any) => {
        CustomToast(err, "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Loader spinning={loading}>
      <Box
        sx={{
          bgcolor: "surface.primary",
          color: "text.primary",
          height: "100vh",
          width: "100vw",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {/* Signup */}
        {step === "signup" && (
          <Signup
            handleGoogleSignIn={handleGoogleLogin}
            handleFailure={() => {
              CustomToast("Google Login Failed", "error");
            }}
            handleEmailSignIn={() => setStep("signupWithEmail")}
            termsAndServiceLink="/terms"
            privacyPolicyLink="/privacy"
          />
        )}

        {/* Signup With Email */}
        {step === "signupWithEmail" && (
          <SignupWithEmail
            setEmail={setEmail}
            email={email}
            setPassword={setPassword}
            password={password}
            confirmPassword={confirmPassword}
            setConfirmPassword={setConfirmPassword}
            handleGoBack={() => setStep("signup")}
            handleContinue={handleFormSubmit}
          />
        )}
      </Box>
    </Loader>
  );
};

export default Authentication;
